import { useState } from 'react'
import { useResErrors } from 'hooks/index'
import { SalesService, SeoService } from 'lib/api'
import { useAuthStore } from 'context/AuthStore'
import { useModalbar } from '../modules/Modalbar'

const useSeoApis = () => {
  const [ticketLoading, setLoading] = useState(false)
  const { standardCheck, silentCheck } = useResErrors()

  const {
    authStore,
    authStoreFunc: { authManagerInSeo }
  } = useAuthStore()

  const { callModalbar } = useModalbar()

  const reInviteClient = async ({
    onSuccess = () => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)
    await SeoService.reInviteClient(authStore.seoToken)().then(res =>
      standardCheck(res, onSuccess, {
        onFail,
        textErr
      })
    )
    setLoading(false)
  }

  const rejectClient = async ({
    onSuccess = () => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)
    await SeoService.rejectClient(authStore.seoToken)().then(res =>
      standardCheck(res, onSuccess, {
        onFail,
        textErr
      })
    )
    setLoading(false)
  }

  const startTicket = async ({
    onSuccess = () => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)
    await SeoService.startTicket(authStore.seoToken)().then(res =>
      standardCheck(
        res,
        ({ data }) => {
          if (!data?.error) {
            onSuccess(res)
          } else {
            callModalbar(
              'Проблема СЭО , ' + data?.code,
              data?.error ??
                '' +
                  ' .При закрытии будет попытка переавторизации в СЭО (startTicket)',
              {
                variant: 'error',
                onCloseAction: async () => {
                  await authManagerInSeo()
                }
              }
            )
          }
        },
        {
          onFail: () => {
            callModalbar(
              'Проблема СЭО , ' + res?.data?.code,
              res?.data?.error ??
                '' +
                  ' .При закрытии будет попытка переавторизации в СЭО (startTicket)',
              {
                variant: 'error',
                onCloseAction: async () => {
                  await authManagerInSeo()
                }
              }
            )
          },
          textErr
        }
      )
    )
    setLoading(false)
  }

  const redirectClient = async ({
    target,
    saleId,
    onSuccess = () => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)
    await SeoService.redirectClient(authStore.seoToken)(target, saleId).then(
      res =>
        standardCheck(
          res,
          ({ data }) => {
            if (data.code === 13) {
              SalesService.redirectClientSale(authStore.seoToken)(
                target,
                saleId
              )

              return onSuccess(res)
            } else {
              onSuccess(null)
              callModalbar(
                'Проблема СЭО , ' + data.code,
                data.error ??
                  '' +
                    ' .При закрытии будет попытка переавторизации в СЭО (redirectClient)',
                {
                  variant: 'error',
                  onCloseAction: async () => {
                    setLoading(true)
                    await authManagerInSeo()
                    setLoading(false)
                  }
                }
              )
            }
          },
          {
            onFail,
            textErr
          }
        )
    )
    setLoading(false)
  }

  const closeTicket = async ({
    onSuccess = () => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)

    await SeoService.closeTicket(authStore.seoToken)().then(response =>
      standardCheck(
        response,
        ({ data }) => {
          if (data.code === 12) {
            onSuccess(response)
          } else {
            callModalbar(
              'Проблема СЭО , ' + data.code,
              data.error ??
                '' +
                  ' .При закрытии будет попытка переавторизации в СЭО (closeTicket)',
              {
                variant: 'error',
                onCloseAction: async () => {
                  setLoading(true)
                  await authManagerInSeo()
                  setLoading(false)
                }
              }
            )
          }
        },
        {
          onFail,
          textErr
        }
      )
    )

    setLoading(false)
  }

  const getDepartments = async ({
    onSuccess = () => {},
    onFail = () => {},
    textErr
  }) => {
    onSuccess(authStore?.seoDepartments)
  }

  /*
   * 4	Оператор сейчас свободен и может пригласить новый талон
   * 5 Оператор уже пригласил талон, но приём пока не начался
   * 6 Оператор уже пригласил талон и приём начался
   */
  const hasActiveTicket = async ({
    onSuccess = () => {},
    onFail = () => {},
    textErr
  }) => {
    let code = null
    setLoading(true)
    await SeoService.getStatus(authStore.seoToken)().then(res =>
      silentCheck(
        res,
        () => {
          const { data } = res
          code = data.code
          if (data.code === 4) return onSuccess?.(null)
          if ([5, 6].includes(data.code)) {
            return onSuccess({
              code: data.code,
              ticketNumber: data.TicketNum,
              ticketId: data.Id
            })
          }
          return onSuccess?.(null)
        },
        {
          onFail,
          textErr
        }
      )
    )
    setLoading(false)
    return code
  }

  const getStatus = async ({
    onSuccess = () => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)
    await SeoService.getStatus(authStore.seoToken)().then(res =>
      standardCheck(res, onSuccess, {
        onFail,
        textErr
      })
    )
    setLoading(false)
  }

  const getStat = async ({
    onSuccess = () => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)
    await SeoService.getStat(authStore.seoToken)().then(res =>
      standardCheck(res, onSuccess, {
        onFail,
        textErr
      })
    )
    setLoading(false)
  }

  return {
    seoLoading: ticketLoading,
    redirectClient,
    getDepartments,
    startTicket,
    closeTicket,
    hasActiveTicket,
    rejectClient,
    reInviteClient,
    getStat,
    getStatus
  }
}

export default useSeoApis
